import React, { useState } from 'react';
import { Copy, Check, Sparkles } from 'lucide-react';
import MarkdownLite from './markdownLite';

export default function ChatBubble({ message }) {
  const isUser = message.role === 'user';
  const isError = !!message.error;
  const isStreaming = !!message.streaming;
  const isAssistant = !isUser && !isError;
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (typeof navigator !== 'undefined' && navigator.clipboard) {
      navigator.clipboard.writeText(message.content || '').then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      });
    }
  };

  return (
    <div className={`flex gap-2 mb-3 ${isUser ? 'justify-end' : 'justify-start'}`}>
      {isAssistant && (
        <div className="flex-shrink-0 w-7 h-7 mt-1 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-sm">
          <Sparkles size={14} className="text-white" />
        </div>
      )}
      <div className={`group relative max-w-[80%] ${isUser ? 'order-2' : ''}`}>
        <div
          className={`rounded-2xl px-4 py-2.5 text-sm shadow-sm ${
            isUser
              ? 'bg-blue-600 text-white rounded-br-md'
              : isError
                ? 'bg-red-50 text-red-700 border border-red-200'
                : 'bg-white text-gray-800 border border-gray-200 rounded-bl-md'
          }`}
        >
          {isAssistant && !isStreaming ? (
            <MarkdownLite content={message.content} />
          ) : (
            <span className="whitespace-pre-wrap">{message.content}</span>
          )}
          {isStreaming && (
            <span className="inline-block w-1.5 h-4 ml-0.5 align-middle bg-current opacity-70 animate-pulse" />
          )}
        </div>
        {isAssistant && !isStreaming && message.content && (
          <button
            onClick={handleCopy}
            className="absolute -bottom-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity bg-white border border-gray-200 rounded-md p-1 shadow-sm hover:bg-gray-50"
            aria-label="Copy"
            title={copied ? 'Copié !' : 'Copier'}
          >
            {copied ? <Check size={12} className="text-green-600" /> : <Copy size={12} className="text-gray-500" />}
          </button>
        )}
      </div>
    </div>
  );
}
